export const INTEGRATIONS_LOGS = [
  "name",
  "type",
  "status",
  "description",
  "error",
  "expression",
  "start",
  "end",
];
